/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import TableRow from "../../Helpers/Table/TableRow";
import TableActions from "../../Helpers/Table/TableActions";
//import { useLazyGetChildUsersQuery } from "../../../Redux/service/Users/Users";
import { filtrationcontext } from "../../../context/Filtercontext";
import { popupcontext } from "../../../context/Popupscontext";
import Empty from "../../Helpers/Empty/Empty";
import trans from "../../../utils";

export default function UsersTableBody({ data }) {
	let { searchQuery } = useContext(filtrationcontext);
	let { refetchTrigger, tryRefetch, deleteItem, setDeleteItem } =
		useContext(popupcontext);
	//let [getChildUser] = useLazyGetChildUsersQuery();
	//const [subUsersData, setSubUsersData] = useState([]);
	//console.log("subUsersData", subUsersData);
	/* useEffect(() => {
    if (data?.length) {
      data.forEach((user) => {
        getChildUser(user.id)
          .then((result) => {
            if (result && Array.isArray(result.data)) {
              setSubUsersData((prev) => ({
                ...prev,
                [user.id]: result.data,
              }));
            } else {
              setSubUsersData((prev) => ({
                ...prev,
                [user.id]: 0,
              }));
            }
          })
          .catch((error) => {
            console.error(
              `Error fetching sub-users for user ${user.id}:`,
              error
            );
            setSubUsersData((prev) => ({
              ...prev,
              [user.id]: 0,
            }));
          });
      });
    }
  }, [data, getChildUser, refetchTrigger]);*/
	useEffect(() => {
		async function fetchdata() {
			if (deleteItem.condition === true && deleteItem.value === "users") {
				tryRefetch();
				setDeleteItem({ condition: null, value: null });
			}
		}
		fetchdata();
	}, [
		deleteItem.condition,
		deleteItem.value,
		tryRefetch,
		refetchTrigger,
		setDeleteItem,
	]);
	let FilteredData = data?.filter(
		(i) =>
			i.administrator === true ||
			(i.administrator === false && (i.userLimit > 0 || i.userLimit >= -1))
	);

	let SearchFilteredData = FilteredData;
	if (searchQuery) {
		SearchFilteredData = FilteredData.filter((user) =>
			user.name.toLowerCase().includes(searchQuery.toLowerCase())
		);
	}

	return (
		<>
			{SearchFilteredData?.length > 0 ? (
				SearchFilteredData.map((i) => {
					const role = (admin, ulimit) => {
						if (admin === false && (ulimit > 0 || ulimit === -1)) {
							return "Manager";
						} else if (admin === false && ulimit === 0) {
							return "Regular User";
						} else {
							return "Admin";
						}
					};
					const type = () => {
						if (i.deviceReadonly === true) {
							return "Device Readonly";
						} else if (i.readonly === true) {
							return "Readonly";
						} else if (i.userLimit === 0 && i.deviceLimit === 0) {
							return "Readonly";
						} else {
							return "- - - - -";
						}
					};
					const checkExpire = () => {
						if (Date.now() > new Date(i.expirationTime).getTime()) {
							return false;
						} else {
							return true;
						}
					};
					return (
						<div key={i.id} className="table-row">
							<TableRow value={i.name} style="table-element-code ps-0" />
							<TableRow value={role(i.administrator, i.userLimit)} />
							<TableRow value={type()} />
							<TableRow
								value={checkExpire() ? trans("Active") : trans("Expired")}
								style={
									checkExpire() ? "table-element-success" : "table-element-fail"
								}
								valuestyle={
									checkExpire()
										? "table-bg-element-success"
										: "table-bg-element-fail"
								}
							/>
							<TableRow
								value={i.phone ? i.phone : "- - - - -"}
								style="table-element-code"
							/>
							<TableRow
								style="table-element-email"
								value={i.email.replace("@gmail.com", "\n@gmail.com")}
							/>
							{/* <TableRow
                value={
                  subUsersData[i.id] !== undefined
                    ? subUsersData[i.id]?.length
                    : "-"
                }
                view={{
                  status:
                    (subUsersData[i.id]?.length === 0) === true ||
                    i.administrator === true
                      ? false
                      : true,
                  type: "users",
                  id: i.id,
                  data: subUsersData[i.id],
                  name: i.name,
                }}
              />*/}
							<TableActions
								userId={i.id}
								name={i.name}
								type="link"
								login={true}
								role={type()}
								expired={checkExpire()}
							/>
						</div>
					);
				})
			) : (
				<Empty
					title={trans("No users found")}
					subtitle={trans("Create your first user now!")}
				/>
			)}
		</>
	);
}
